import { render, staticRenderFns } from "./VouchersEdit.vue?vue&type=template&id=143450c4"
import script from "./VouchersEdit.vue?vue&type=script&lang=js"
export * from "./VouchersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports